import get from 'lodash.get';
import { fetchOlderCards } from 'redux/modules/liveBlog';
import BTE from 'lib/BTE';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { shouldRenderRegularBlog } from 'lib/liveBlog';

dayjs.extend(utc);

const loadMoreQueryLimit = 10;

export const loadMoreCards = (props) => {
  const { activeItems = [], content: { taxonomy: { path } }, dispatch } = props;

  const oldestCard = activeItems.length && activeItems[activeItems.length - 1];

  if (!oldestCard) return null;

  const datePublished = get(oldestCard, 'date.publishedAt');
  const oldestCardId = get(oldestCard, 'id');

  return dispatch(fetchOlderCards({
    path, queryLimit: loadMoreQueryLimit, datePublished, excludeCard: oldestCardId,
  }));
};

export const articleViewHandler = (event, props) => {
  if (event && event[0] && event[0].isIntersecting) {
    const id = get(props, 'articles[0].id');
    BTE.trigger('articleInView', id);
  }
};

export const blogMapStateToProps = ({ article, liveBlog, router }) => ({
  flag: get(article, 'content[0].flag', null),
  activeItems: liveBlog.activeItems,
  path: router.path,
  domain: router.domain,
  fetchingLatest: liveBlog.fetchingLatest,
  numberOfNewItems: liveBlog.numberOfNewItems,
  loadingMoreCards: liveBlog.loadingMoreCards,
  trueTotalItems: liveBlog.trueTotalItems,
  isCanonicalCard: !!get(liveBlog, 'card.id', null),
  isRegularBlog: shouldRenderRegularBlog(get(article, 'content[0].subType', null)),
});

export const getDatePublished = (card) => {
  let datePublished;
  if (card) {
    const { date: { publishedAt } } = card;
    datePublished = dayjs(publishedAt).utc().format();
  }
  return datePublished;
};
